import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from '@repo/ui';
import { format } from 'date-fns';

interface DexVolume {
  date: string;
  dex_name: string;
  volume_usd: number;
  trade_count: number;
}

interface DexVolumeChartProps {
  data: DexVolume[];
}

export function DexVolumeChart({ data }: DexVolumeChartProps) {
  // 최근 7일 데이터만 사용
  const uniqueDates = Array.from(new Set(data.map(d => d.date)))
    .sort()
    .reverse()
    .slice(0, 7)
    .reverse();
  
  const chartData = uniqueDates.map(date => {
    const dayData = data.filter(d => d.date === date);
    const result: any = {
      date: format(new Date(date), 'MM/dd'),
    };
    
    dayData.forEach(d => {
      result[d.dex_name] = d.volume_usd;
    });
    
    return result;
  });
  
  // DEX 이름 추출
  const dexNames = Array.from(new Set(data.map(d => d.dex_name)));
  const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444'];
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>DEX Trading Volume (7 Days)</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis 
              tickFormatter={(value) => `$${(value / 1000000).toFixed(1)}M`}
            />
            <Tooltip 
              formatter={(value: number | undefined) => value !== undefined ? `$${value.toLocaleString()}` : 'N/A'}
              labelFormatter={(label) => `Date: ${label}`}
            />
            <Legend />
            {dexNames.map((dex, idx) => (
              <Bar 
                key={dex}
                dataKey={dex} 
                fill={colors[idx % colors.length]}
                name={dex}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
